import { MainLayout } from '@components/layouts/main.layout';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import type { FC } from 'react';
import { TechChallengesGrid } from './components/tech-challenges-grid.component';

export const TechChallengesListPage: FC = () => {
  return (
    <PageviewTracker>
      <HelmetWrapper title="Tech Challenges" />
      <MainLayout fullWidth>
        <TechChallengesGrid className="mx-auto w-full max-w-(--breakpoint-lg)" />
      </MainLayout>
    </PageviewTracker>
  );
};
